import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ItemsAddedDialogState = {
    open: false,
    productsAdded: null,
    handleGoToCart: null,
    handleClose: null,
    translateKeyPrefix: null,
    translateNS: null,
};

export const itemsAddedDialogSlice = createSlice({
    name: 'items-added-dialog',
    initialState,
    reducers: {
        openDialog: (state, action: PayloadAction<setDialogOpenPayload>) => {
            state.productsAdded = action.payload.productsAdded;
            state.open = action.payload.open;
            // state.translateKeyPrefix = action.payload.translateKeyPrefix;
            // state.translateNS = action.payload.translateNS;
            // state.handleGoToCart = action.payload.handleGoToCart;
            // state.handleClose = action.payload.handleClose;
        },
        setDialog: (state, action: PayloadAction<setDialogItemsPayload>) => {
            state.translateKeyPrefix = action.payload.translateKeyPrefix;
            state.translateNS = action.payload.translateNS;
            state.handleGoToCart = action.payload.handleGoToCart;
            state.handleClose = action.payload.handleClose;
        },
        closeDialog: (state) => {
            state.open = false;
            state.productsAdded = null;
            state.handleGoToCart = null;
            state.handleClose = null;
            state.translateKeyPrefix = null;
            state.translateNS = null;
        },
    },
});

export interface ItemsAddedDialogState {
    open: boolean;
    productsAdded: 'all' | 'none' | 'partially';
    translateKeyPrefix: string;
    translateNS: string;
    handleGoToCart?: () => void;
    handleClose?: () => void;
}

interface setDialogOpenPayload {
    open: boolean;
    productsAdded: 'all' | 'none' | 'partially';
}

interface setDialogItemsPayload {
    translateKeyPrefix: string;
    translateNS: string;
    handleGoToCart?: () => void;
    handleClose?: () => void;
}

export const itemsAddedDialogAction = itemsAddedDialogSlice.actions;

export default itemsAddedDialogSlice.reducer;
